var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "banner" }, [
    _c(
      "div",
      { staticClass: "banner__wrapper" },
      [
        _c("MainPageAnimation"),
        _c(
          "div",
          { staticClass: "banner__container" },
          [
            _c("BaseTitle", {
              staticClass: "banner__title",
              attrs: { tag: "h1", text: _vm.titleText }
            }),
            _c("BaseText", {
              staticClass: "banner__descr",
              attrs: { text: _vm.descriptionText }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a1fd6b94", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1fd6b94","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/BannerBlock.vue
// module id = 99Pu
// module chunks = 0